import { Celebration } from '../../uiKit/assets/svg/celebration.js'
import Feedback from '../../components/Feedback/feedback';

const OurBalanceThankYou = ({ onClose }) => {
    return (
        <div className='createdPage'>
            <Feedback
                title="Thank you"
                firstDescription='You have helped your community.'
                secondDescription='Be proud.'
                button={{
                    feedbackTitle: 'Our balance page',
                    feedbackAction: () => onClose(),
                    disable: false
                }}
                Image={Celebration}
                titleFontSize={24}
            />
        </div>
    )
}

export default OurBalanceThankYou;